// extracted by mini-css-extract-plugin
module.exports = {"DotWave":"_3y0DqIi09vCpBFZ3tetisA"};